let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5Xo4r")).then(() => parcelRequire('hPBOL'));